import type { SharedData } from "@src/context/ApplicationContext";

export const TEST_RECORD_BLOCK_MESSAGE = "This is a test record. Scheduling is disabled.";

/**
 * Returns true when the current session originates from a Salesforce test lead
 * and scheduling (freeze/book) must be blocked.
 */
export const isTestRecordBlocked = (data?: Partial<SharedData> | null): boolean => {
  return data?.testRecord === true;
};
